import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import "../i18n/i18n";

const useLanguageInitializer = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // English-only for now. Country-based auto language is disabled.
    // To re-enable later:
    // 1. import useGeoCountry + languageMap
    // 2. map country → default language from `src/i18n/languageMap.js`
    // 3. use saved localStorage language or country default
    //
    // const country = useGeoCountry();
    // const savedLanguage = localStorage.getItem("language");
    // if (savedLanguage) {
    //   i18n.changeLanguage(savedLanguage);
    //   return;
    // }
    // i18n.changeLanguage(languageMap[country] || "en");

    i18n.changeLanguage("en");
    localStorage.setItem("language", "en");
  }, [i18n]);
};

export default useLanguageInitializer;
